<template>
  <v-app class="app-tabela">
    <div class="box" style="margin-top: 0px">
      <v-card class="tabela">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Nome"
            class="input-bottom"
            single-line
            hide-details
          ></v-text-field>
        </v-card-title>
        <v-data-table
          @pagination="getPagination"
          :page="currentPage"
          :footer-props="{
            itemsPerPageText: '',
            'items-per-page-options': [10],
            'disable-items-per-page': true,
          }"
          :loading="loading"
          loading-text="Carregando, Por favor espere"
          :headers="headers"
          :item-class="getRowColor"
          :items="indexedItems"
          :search="search"
          item-key="id"
          class="elevation-1"
          :single-expand="true"
          :expanded.sync="expanded"
          show-expand
        >
          <!-- <template #footer.prepend>
          <v-spacer />
        </template> -->

          <template v-slot:header.micro_area="{ header }">
            {{ header.text }}
            <span
              v-b-tooltip.hover.right
              title="Microárea do ACS"
              class="icon-tooltip"
            >
              <i class="icofont-info-circle"></i>
            </span>
          </template>

          <template v-slot:item.dt_nascimento="{ item }">
            {{ formatDate(item.dt_nascimento) }}
          </template>

          <template v-slot:item.dt_aplicacao="{ item }">
            <div
              v-if="item.dias_ult_dose == null || item.dias_ult_dose > 365"
              class="doses-list-button red"
              @click="openModalVacina(item)"
            >
              <strong>ÚNICA</strong>
            </div>
            <div
              v-else
              class="doses-list-button green"
              @click="openModalVacina(item)"
            >
              <strong>{{ formatDate(item.dt_aplicacao) }}</strong>
            </div>
          </template>

          <template v-slot:expanded-item="{ headers, item }">
            <td colspan="8">
              <table class="table table-interna">
                <thead>
                  <tr>
                    <th>CPF</th>
                    <th>CNS</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      {{ item.nu_cpf }}
                    </td>
                    <td>
                      {{ item.nu_cns }}
                    </td>
                  </tr>
                </tbody>
              </table>
            </td>
          </template>

          <template v-slot:[`footer.page-text`]="items">
            <div class="info-table-item tabela-esus-pec">
              <FonteSincronizadorC />
            </div>
            <span class="paginacao"
              >{{ items.pageStart }} - {{ items.pageStop }} de
              {{ items.itemsLength }} pessoas</span
            >
          </template>

          <template v-slot:progress>
            <v-progress-linear
              color="blue"
              :height="10"
              indeterminate
            ></v-progress-linear>
          </template>
          <template v-slot:no-data>
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
          <template v-slot:no-results style="padding: 0px">
            <div class="alert alert-info mb-0">
              <b>Nenhuma informação encontrada. Selecione outro filtro.</b>
            </div>
          </template>
        </v-data-table>
      </v-card>
    </div>

    <!-- Modal vacina -->
    <b-modal
      id="modal2"
      title="Influenza trivalente"
      v-model="modalVacinas.show"
      :modal-class="'modal-zindex-top'"
      centered
      scrollable
      hide-footer
    >
      <ValidationObserver ref="observerModalVacinas" class="row">
        <div class="col-lg-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="mb-2">
              <the-mask
                :mask="['##/##/####']"
                v-model="modalVacinas.form.dataAplicacao"
                required
                class="form-control"
                placeholder="Data da aplicação"
                :disabled="
                  modalVacinas.form.btn.loading || !modalVacinas.form.podeEditar
                "
              />
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-lg-6">
          <validation-provider v-slot="{ errors }" rules="required">
            <div class="mb-2">
              <input
                name="lote"
                v-model="modalVacinas.form.lote"
                class="form-control"
                placeholder="Lote"
                type="text"
                required
                :disabled="
                  modalVacinas.form.btn.loading || !modalVacinas.form.podeEditar
                "
              />
            </div>
            <div class="error">{{ errors[0] }}</div>
          </validation-provider>
        </div>
        <div class="col-lg-12">
          <button
            type="submit"
            class="btn mt-2"
            :disabled="
              modalVacinas.form.btn.loading || !modalVacinas.form.podeEditar
            "
            v-on:click="salvarVacina(modalVacinas.item)"
          >
            Salvar
            <b-spinner
              small
              label="Small Spinner"
              variant="white"
              v-if="modalVacinas.form.btn.loading"
            ></b-spinner>
          </button>
        </div>
      </ValidationObserver>
    </b-modal>
  </v-app>
</template>

<script>
import utils from '@/mixins/utils.js'
import ShowHideField from '@/components/utils/ShowHideField.vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { validations } from '@/mixins/validations'
validations()
import { TheMask } from 'vue-the-mask'

export default {
  name: 'TabelaCadastros',
  components: {
    ShowHideField,
    ValidationObserver,
    ValidationProvider,
    TheMask,
  },
  props: {
    cadastros: {
      type: Array,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [utils],
  data() {
    return {
      currentPage: 1,
      expanded: [],
      enabled: null,
      search: '',
      headers: [
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          value: 'no_cidadao',
        },
        {
          text: 'Nascimento',
          align: 'start',
          filterable: false,
          value: 'dt_nascimento',
        },
        {
          text: 'Mãe',
          align: 'start',
          filterable: false,
          value: 'no_mae',
        },
        {
          text: 'MA',
          align: 'start',
          filterable: false,
          value: 'micro_area',
        },
        {
          text: 'Influenza Trivalente',
          align: 'start',
          filterable: false,
          value: 'dt_aplicacao',
        },
        { text: '', value: 'data-table-expand' },
      ],
      modalVacinas: {
        show: false,
        item: null,
        form: {
          dataAplicacao: null,
          lote: null,
          btn: {
            disabled: false,
            loading: false,
          },
          podeEditar: true,
          mode: 'create',
        },
      },
    }
  },
  computed: {
    indexedItems() {
      return this.cadastros.map((item, index) => ({
        id: index,
        ...item,
      }))
    },
  },
  mounted() {},
  watch: {
    cadastros: {
      handler(newValue, oldValue) {
        this.currentPage = 1
      },
      deep: true,
    },
    search: {
      handler(newValue) {
        if (newValue) {
          this.$emit('filterSearch', { filter: this.filterItems(newValue) })
          return
        }
        this.$emit('filterSearch', { filter: false })
      },
      deep: true,
    },
  },
  methods: {
    /**
     * Filtra os registros da tabela com base no texto de busca.
     * Considera apenas as colunas marcadas como filtráveis nos headers.
     * @param {String} search Texto digitado para pesquisa
     * @returns {Array} Lista de itens filtrados
     */
    filterItems(search) {
      const searchTerms = search.toLowerCase().trim()
      const filteredItems = this.cadastros.filter((item) => {
        for (const header of this.headers) {
          if (header.filterable && item.hasOwnProperty(header.value)) {
            const itemValue = String(item[header.value]).toLowerCase()
            if (itemValue.includes(searchTerms)) {
              return true
            }
          }
        }
        return false
      })
      return filteredItems
    },

    /**
     * Atualiza a página atual da tabela.
     * @param {Object} options Dados da paginação
     */
    getPagination(options) {
      this.currentPage = options.page
    },

    /**
     * Retorna a classe CSS da linha da tabela.
     *
     * @param {Object} item
     *
     * @returns {String}
     */
    getRowColor(item) {
      if (item.dias_ult_dose == null) return 'table-row-color-red'

      if (item.dias_ult_dose > 365) {
        return 'table-row-color-red'
      } else {
        return 'table-row-color-green'
      }
    },

    /**
     * Reseta o form do modal vacinas
     */
    resetFormVacina() {
      this.modalVacinas.form.dataAplicacao = null
      this.modalVacinas.form.lote = null
      this.modalVacinas.form.btn.loading = false
      this.modalVacinas.form.podeEditar = true
    },

    /**
     * Abre o modal de vacina
     * @param {object} item
     */
    openModalVacina(item) {
      this.resetFormVacina()
      this.modalVacinas.item = item
      this.modalVacinas.form.podeEditar = true
      if (item.vacinas != null) {
        this.modalVacinas.form.mode = 'edit'
        this.prefillFormVacina(item.vacinas)
      } else {
        this.modalVacinas.form.mode = 'create'
      }
      this.modalVacinas.show = true
    },

    /**
     * Preenche o form do modal vacina
     * @param {object} item
     */
    prefillFormVacina(item) {
      let doseParsed = JSON.parse(item)
      let dose = doseParsed[0]

      let orig = dose?.orig

      // só edita se orig == 3
      if (String(orig ?? '') !== '3') {
        this.modalVacinas.form.podeEditar = false
      }

      // lote
      if (dose?.lt != null && String(dose.lt).trim() !== '') {
        this.modalVacinas.form.lote = dose.lt
      } else {
        this.modalVacinas.form.lote = null
      }

      // data aplicação
      if (
        dose?.dt_aplicacao != null &&
        String(dose.dt_aplicacao).trim() !== ''
      ) {
        this.modalVacinas.form.dataAplicacao = this.formatDate(
          dose.dt_aplicacao
        )
      } else {
        this.modalVacinas.form.dataAplicacao = null
      }
    },

    async getCpfProfissional() {
      const res = await this.$api.post('/app/auth/usuario', {
        cod_ibge: this.$store.state.cod_ibge,
        id: this.$store.state.id,
      })

      const cpf = res?.data?.cpf
      if (!cpf) {
        return null
      }

      return cpf
    },

    async salvarVacina(item) {
      try {
        if (!this.modalVacinas.form.podeEditar) return

        const isValid = await this.$refs.observerModalVacinas.validate()

        if (!isValid) return

        this.modalVacinas.form.btn.loading = true

        const cpfProfissional = await this.getCpfProfissional()
        if (!cpfProfissional) return

        // Salvar efb vacina
        let response = await this.$api.post('/app/efb-vacina', {
          co_ibge: this.$store.state.cod_ibge,
          cfcp: item.nu_cpf ?? item.nu_cns,
          nu_cns: item.nu_cns,
          nu_cpf: item.nu_cpf,
          cpf_profissional: cpfProfissional,
          id_imunobiologico: '33',
          id_dose_imunobiologico: '9',
          lote: this.modalVacinas.form.lote,
          dt_aplicacao: this.converterParaDataIso(
            this.modalVacinas.form.dataAplicacao
          ),
        })
        if (!response) return

        if (response.data.error === false) {
          this.$toast.success('Vacina salva com sucesso!', 'Sucesso:', {
            position: 'topRight',
          })
        } else {
          this.$toast.error('Erro ao salvar vacina!', 'Erro:', {
            position: 'topRight',
          })
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.modalVacinas.form.btn.loading = false
      }
    },
  },
}
</script>

<style scoped lang="scss">
.doses-list-button {
  cursor: pointer;
  background-color: #fff;
  width: 150px;
  margin: 10px 0;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  padding: 10px;
  border: 1px solid #ccc;
  color: #000;
  border-radius: 6px;
  &.red {
    background: #ffb3b3 !important;
    // border-color: #990000 !important;
  }
  &.green {
    background: #b3ffb3;
    // border-color: #008000 !important;
  }
  &.white {
    background: #fff;
    // border-color: #000 !important;
  }
}
</style>
